/**
 * Pericope section — displays the passage title and verse range
 * for the section containing the queried verse.
 */

import type { PericopeInfo } from '@skjv/common';

interface PericopeSectionProps {
  pericope: PericopeInfo;
}

export function PericopeSection({ pericope }: PericopeSectionProps) {
  const range = pericope.startVerse === pericope.endVerse
    ? `${pericope.chapter}:${pericope.startVerse}`
    : `${pericope.chapter}:${pericope.startVerse}-${pericope.endVerse}`;

  return (
    <div className="rich-message-section pericope-section">
      <h4 className="rich-message-section-title">In Context</h4>
      <p className="pericope-title">{pericope.title}</p>
      <p className="pericope-range">
        {pericope.book} {range}
      </p>
      {pericope.description && <p className="pericope-description">{pericope.description}</p>}
      {pericope.summary && <p className="pericope-summary">{pericope.summary}</p>}
    </div>
  );
}
